import React from 'react';
import { Card, CardImg, CardTitle, CardText, Row, Col } from 'reactstrap';

import Css from './RecommendationTile.scss';

const RecommendationFrame = props => {
  return (
    <div className={'mt-4 px-2 d-flex col-xs-12 col-lg'}>
      <div
        className={
          Css.RecommendationTile +
          ' px-0 text-center border-right border-bottom border-left'
        }
      >
        <a
          href={props.LinkUrl}
          className={Css.RecommendationLink}
          target={'_blank'}
          onClick={() => {
            window.gtag('event', 'click', {
              event_category: 'JS-Experiences-Engagement',
              event_label:
                props.location + ' - ' + props.FrameHeader + ' - Clicks'
            });
          }}
        >
          <Card className={'border-0 text-center ' + Css.container}>
            <Row>
              <Col
                xs={6}
                md={12}
                className={
                  props.index % 2 === 1 ? 'order-reverse' : 'order-normal'
                }
              >
                <CardImg
                  className="card-img-top mb-4"
                  src={props.ImgUrl}
                  alt="Card image cap"
                />
              </Col>
              <Col xs={6} md={12} className={'d-flex align-items-center'}>
                <div>
                  <CardTitle
                    className={Css.RecommendationTitle + ' px-4 font-mid'}
                  >
                    {props.FrameHeader}
                  </CardTitle>

                  <CardText
                    className={Css.RecommendationText + ' px-4 font-mid'}
                  >
                    {props.FrameText}
                  </CardText>
                </div>
              </Col>
            </Row>
          </Card>
        </a>
      </div>
    </div>
  );
};

export default RecommendationFrame;



// WEBPACK FOOTER //
// ./src/components/ExperiencesLandingPage/RecommendationTile/RecommendationTile.js